import React, { Component } from 'react';
import { connect } from 'react-redux';
import NoticeStoreListWrap from '../../views/notice/store/list/NoticeStoreListWrap';
import { noticeStoreActions } from '../../store/modules/notice/store';
import {
  NOTICE_STORE_LIST_FILTER_OPTION_MODEL,
  NOTICE_STORE_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/notice/store/models';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { asyncSimpleModal } from '../../lib/common';

class NoticeStoreListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { getNoticeStoreList } = this.props;
    getNoticeStoreList({
      filterOption: NOTICE_STORE_LIST_FILTER_OPTION_MODEL,
      sortOption: NOTICE_STORE_LIST_SORT_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  getList = (data) => {
    const { getNoticeStoreList, noticeStoreList } = this.props;
    const { filterOption, sortOption, pagination } = noticeStoreList;
    getNoticeStoreList({
      filterOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  getExcelDownload = () => {
    const { getNoticeStoreExcelDownload, noticeStoreList } = this.props;
    const { filterOption, sortOption } = noticeStoreList;

    getNoticeStoreExcelDownload({
      filterOption,
      sortOption,
    });
  };

  /**
   *  공지사항 삭제하기
   */
  deleteNoticeStore = async (data) => {
    const { deleteNoticeStore } = this.props;

    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '공지사항 삭제',
      message: '해당 공지사항을 삭제합니다. 계속 진행하시겠습니까? ',
    });

    if (!confirmResult) return;

    deleteNoticeStore(data);
  };

  render() {
    const { noticeStoreList } = this.props;

    return (
      <NoticeStoreListWrap
        noticeStoreList={noticeStoreList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
        deleteNoticeStore={this.deleteNoticeStore}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    noticeStoreList: state.noticeStore.noticeStore.noticeStoreList,
  };
};

const mapDispatchToProps = {
  getNoticeStoreList: noticeStoreActions.getNoticeStoreList,
  getNoticeStoreExcelDownload: noticeStoreActions.getNoticeStoreExcelDownload,
  deleteNoticeStore: noticeStoreActions.deleteNoticeStore,
};

export default connect(mapStateToProps, mapDispatchToProps)(NoticeStoreListContainer);
